import React, { useState } from 'react'
//import Estilos from '../paginas/estilos/estilos.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'

import Logo from '../../paginas/img/logo.png'

const FormularioLogin = ({ onChange, form, onSubmit, errorForm, sede, errors, isSubmitting }) => {
	const [mostrarClave, setMostrarClave] = useState(false)

	return (
		<div className="Login">

			<div className="contLogin align-self-center text-center container">
				<div className="card-body px-lg-5 pt-0">

					<img className="Logo_login" src={Logo} />

					<form className="text-center" onSubmit={onSubmit}>

						<div className="md-form">
							<input
								type="text"
								className={`form-control ${errors?.usuario ? 'is-invalid' : ''}`}
								name="usuario"
								placeholder="Usuario"
								onChange={onChange}
								value={form.usuario}
								autoComplete="username"
							/>
							{errors?.usuario ? <div className="invalid-feedback d-block text-left">{errors.usuario}</div> : null}
						</div>

						<div className="md-form">
							<div className="login-password-group">
								<input
									type={mostrarClave ? 'text' : 'password'}
									className={`form-control login-password-input ${errors?.clave ? 'is-invalid' : ''}`}
									name="clave"
									placeholder="Contraseña"
									onChange={onChange}
									value={form.clave}
									autoComplete="current-password"
								/>
								<button
									type="button"
									className="login-password-toggle"
									onClick={() => setMostrarClave(!mostrarClave)}
									aria-label={mostrarClave ? 'Ocultar contraseña' : 'Mostrar contraseña'}
								>
									<FontAwesomeIcon icon={mostrarClave ? faEyeSlash : faEye} />
								</button>
							</div>
							{errors?.clave ? <div className="invalid-feedback d-block text-left">{errors.clave}</div> : null}
						</div>
						{errorForm && !errors?.usuario && !errors?.clave ? <p className='animated bounceInRight'>{errorForm}</p> : null}
						<button type="submit" disabled={isSubmitting} className="btn boton_estandar btn-rounded btn-block my-4 btn-lg">
							{isSubmitting ? 'Ingresando...' : 'Ingresar'}
						</button>
						<span>Sede: {sede}</span>
					</form>


				</div>
			</div>
		</div>
	)

}

export default FormularioLogin
